module.exports = __webpack_public_path__ + "static/media/pixcelboost.e2fdf868.png";